export enum ShopGroupPages {
  BasicInfo = 'basic-info',
}

export default ShopGroupPages;
